import { useMutation } from '@tanstack/react-query';
import { signInWithGoogle } from 'shared/services/google';

export const useLoginUserWithGoogleMutation = () =>
  useMutation({
    mutationFn: async () => signInWithGoogle(),
  });
